
export const siteSelectStyles = {
    container: (base) => ({ ...base, flex: 1, minWidth: 0 }),
    control: (base) => ({
        ...base,
        minHeight: '34px',
        fontSize: '12px',
        borderColor: 'rgba(255,255,255,0.12)',
        backgroundColor: 'rgba(255,255,255,0.03)',
        borderRadius: '4px',
        boxShadow: 'none',
        flexWrap: 'nowrap',
        '&:hover': { borderColor: 'rgba(255,255,255,0.25)' }
    }),
    singleValue: (base) => ({ ...base, color: 'white', fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }),
    placeholder: (base) => ({ ...base, color: 'rgba(255,255,255,0.5)', fontSize: '12px' }),
    input: (base) => ({ ...base, color: 'white', fontSize: '12px' }),
    menu: (base) => ({ ...base, zIndex: 9999, backgroundColor: '#1e163c', border: '1px solid rgba(255,255,255,0.12)', minWidth: '200px' }),
    option: (base, state) => ({
        ...base,
        fontSize: '12px',
        padding: '6px 10px',
        backgroundColor: state.isSelected ? '#CB2C84' : state.isFocused ? 'rgba(0,93,229,0.1)' : 'transparent',
        color: 'white',
        '&:active': { backgroundColor: 'rgba(0,93,229,0.2)' }
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base) => ({ ...base, padding: '4px', color: 'rgba(255,255,255,0.5)', '&:hover': { color: 'white' } }),
    clearIndicator: (base) => ({ ...base, padding: '4px', color: 'rgba(255,255,255,0.5)', '&:hover': { color: 'white' } }),
};
